import helper from "../helper";

let getPassOrderUrl = helper.getPassOrderUrlWithParameters
let getPassOrderAllowed = helper.allowedPassOrderUrl

export default {
    getPassOrderUrl,
    getByRecievedUrlData: (url, gets = null) => getPassOrderUrl(
        url.basename,
        url.action,
        url.params,
        gets
    ),
    RESPONSIBLE: {
        ALLOWED: () => getPassOrderAllowed(
            "employee|orders|orders-list",
            "list"
        ),
        ORDERS: {
            LIST:
                (gets = null) => getPassOrderUrl(
                    "employee|orders|orders-list",
                    "list",
                    null,
                    gets
                ),
            DETAIL:
                (through_number, gets = null) => getPassOrderUrl(
                    "employee|orders|orders-detail",
                    "retrieve",
                    {id: through_number},
                    gets
                )
        }
    }
}